import AttachedMediaList from 'components/shared/MediaBrowser/AttachedMediaList.jsx'
import MediaBrowser from 'components/shared/MediaBrowser/MediaBrowser'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { formValues, registerField } from 'redux-form'
import { clearCreatedMedia, createMedium } from 'redux/media'
import { Divider, Grid, Header, Segment } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { media } = state.media
  return { media }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      registerField,
      createMedium,
      clearCreatedMedia,
    },
    dispatch
  )
}

class UserMedia extends React.Component {
  componentWillMount() {
    const { registerField, form } = this.props
    registerField(form, 'mediaIdList', 'FieldArray')
  }

  addMedium(media) {
    const { mediaIdList = [], array } = this.props
    if (!mediaIdList.includes(media)) array.push('mediaIdList', media.id)
  }

  deleteMedium(index) {
    const { array } = this.props
    array.remove('mediaIdList', index)
  }

  moveMedium(oldIndex, newIndex) {
    const { array } = this.props
    array.swap('mediaIdList', oldIndex, newIndex)
  }

  customActions(medium) {
    return [
      {
        icon: 'book',
        text: I18n.t('admin.mediaBrowser.dealer_document'),
        color: config.semantic_ui.primary_color,
        onClick: (event) => {
          event.preventDefault()
          this.addMedium(medium)
        },
      },
    ]
  }

  render() {
    const dark = config.theme.dark
    // props
    const { mediaIdList = [] } = this.props //formValues

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column computer={8} largeScreen={8} widescreen={8}>
            <MediaBrowser
              addMedium={(mediumId) => this.addMedium(mediumId)}
              customActions={(medium) => this.customActions(medium)}
              allowedTypes={['application/pdf']}
            />
          </Grid.Column>
          <Grid.Column computer={4} largeScreen={4} widescreen={4}>
            <Segment attached className={classNames([dark && 'inverted'])}>
              <Header as="h4" content={I18n.t('admin.user.downloads.title')} />
            </Segment>

            <AttachedMediaList
              mediaIdList={mediaIdList}
              moveMedium={(oldIndex, newIndex) =>
                this.moveMedium(oldIndex, newIndex)
              }
              deleteMedium={(index) => this.deleteMedium(index)}
            />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row>
          <Grid.Column>
            <Divider hidden />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

UserMedia = connect(mapStateToProps, mapDispatchToProps)(UserMedia)
UserMedia = formValues('mediaIdList', 'media')(UserMedia)
export default UserMedia



// WEBPACK FOOTER //
// ./src/components/admin/Users/UserMedia.jsx